import { fetchJsonApi } from './abstract';
import { getApiLanguage } from './language';

/**
 * @return Promise that returns all available tutorials.
 */

export const fetchCampaigns = async (apiUrl) =>
  fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v2/campaigns',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching campaigns',
  });

export default {
  fetchCampaigns,
};
